import { Component, OnInit, Inject } from '@angular/core';
import { User, AuthService, AuthType } from '@anadolu-commons/tohum-ui';
import { HttpHeaders, HttpXsrfTokenExtractor, HttpClient } from '@angular/common/http';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-welcome',
  templateUrl: './welcome.component.html',
  styles: []
})
export class WelcomeComponent implements OnInit {

  user: User;
  authenticated: boolean;
  authTypes: AuthType[];

  constructor(private authService: AuthService, private tokenExtractor: HttpXsrfTokenExtractor,
    @Inject(DOCUMENT) private document: any, private http: HttpClient) { }

  ngOnInit(): void {
    this.user = this.authService.getUser();
    this.authenticated = this.authService.isAuthenticated();


    this.authTypes = [];
        for (const type in this.authService.authTypes) {
            if (this.authService.authTypes.hasOwnProperty(type)) {
                this.authTypes.push(type as AuthType);
            }
        }
  }

  login(){
    const token = this.tokenExtractor.getToken() as string;
        let headers = new HttpHeaders();
        if (token !== null) {
          headers = headers.append('X-XSRF-TOKEN', token);
        }
        this.http.get<any>('/auth/oauth/authorize', { headers }).subscribe(result => {
          this.document.location.href = result.data.redirectUrl;
        });
  }

}
